export enum TaskOrigins {
  AUTOMATIC = 1,
  PHONE = 2,
  EMAIL = 3,
  MAIL = 4,
}
